import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'htmlDecode',
  standalone: true
})
export class HtmlDecodePipe implements PipeTransform {
  private parser = new DOMParser();

  transform(value: string): string {
    return this.parser.parseFromString(value ?? '', 'text/html').body.innerText;
  }

}
